import Image from 'next/image'
import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type BlogAuthorProps = {
  imageSrc: string
  name: string
  role: string
  bio1: string
  bio2: string
}

export const BlogAuthor: FC<React.PropsWithChildren<BlogAuthorProps>> = ({
  imageSrc,
  name,
  role,
  bio1,
  bio2,
}) => (
  <>
    <div className="wrapper">
      <div className="photo">
        <Image
          src={imageSrc}
          alt={name}
          style={{objectFit: 'contain'}}
          fill
          sizes={`${MOBILE_SCREENSIZE} 93px, 115px`}
        />
      </div>
      <div>
        <Text variant={TextVariant.h5} element="p">
          {name}
        </Text>
        <div className="role">
          <Text fontWeight={TextFontWeight.bold} color={theme.palette.text.primary}>
            {role}
          </Text>
        </div>
        <div className="info">
          <Text color={theme.palette.text.light}>{bio1}</Text>
        </div>
        <div className="info">
          <Text color={theme.palette.text.light}>{bio2}</Text>
        </div>
      </div>
    </div>

    <style jsx>{`
      .wrapper {
        display: flex;
        align-items: center;
      }

      .photo {
        position: relative;
        width: 115px;
        height: 115px;
        flex: 0 0 115px;
        margin-right: ${theme.spacing[5]};
      }

      .role {
        margin-top: ${theme.spacing[1]};
        margin-bottom: 12px;
      }

      .info + .info {
        margin-top: ${theme.spacing[1]};
      }

      @media ${MOBILE_SCREENSIZE} {
        .photo {
          width: 93px;
          height: 93px;
          flex: 0 0 93px;
          margin-right: ${theme.spacing[3]};
        }

        .role {
          margin-top: 0;
          margin-bottom: ${theme.spacing[2]};
        }
      }
    `}</style>
  </>
)
